import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import { useStepIndex } from '../stepper/step-index.context';
import { useStepperConfig } from '../stepper/stepper-config.context';

import * as styles from './step-icon-connector.styles';

type Props = {
  children: ReactNode;
  className?: string;
};

export const StepIconConnector = ({ children, className }: Props) => {
  const theme = useTheme();
  const index = useStepIndex();
  const { connectorColor, stepsCount, variant } = useStepperConfig();

  const isLast = index === stepsCount;

  return (
    <div className={className} css={styles.container} data-testid="step-icon-connector">
      {!isLast ? (
        <div css={[styles.connectingLine(theme, connectorColor), styles.connectingLineVariant[variant]]} />
      ) : null}
      {children}
    </div>
  );
};
